import type { MaskPoint } from '../game/types';

export function interpolateTrail(from: MaskPoint, to: MaskPoint, maxStep: number): MaskPoint[] {
  if (!Number.isFinite(maxStep) || maxStep <= 0) {
    throw new RangeError('轨迹采样间距必须大于 0');
  }

  const distance = Math.hypot(to.x - from.x, to.y - from.y);
  const steps = Math.max(1, Math.ceil(distance / maxStep));
  const points: MaskPoint[] = [];

  for (let step = 0; step <= steps; step += 1) {
    const ratio = step / steps;
    points.push({
      x: Math.round(from.x + (to.x - from.x) * ratio),
      y: Math.round(from.y + (to.y - from.y) * ratio),
    });
  }

  return points;
}
